import { IconDialogErrorRed, IconDialogInfo, IconDialogSuccess, IconDialogWarning } from "../../icon";
import { getMessage } from "../../language";
import '../../styles/Dialog/serviceDialog.css';
import { DialogGeneral } from "../../utils/Dialog/dialog";
import { createUUID } from "../../utils/utils";
export enum ETypeDialogService {
    Warning,
    Info,
    Success,
    Error
}

export interface IIunputModalService {
    contentHeader?: string,
    contentBody?: string
}

export class DialogService {
    private _containerId: string
    private _IdGeneral = createUUID()
    private _dialog: DialogGeneral | undefined;

    private _typeDialog: ETypeDialogService
    _action = ''; // or any default value or logic to determine the action
    private promiseResolve: (value: { status: boolean; action: string }) => void = () => { }; // Chứa resolve của Promise
    constructor(input: {
        containerId: string,
        typeDialog: ETypeDialogService
        inputModal: IIunputModalService
    }) {
        this._containerId = input.containerId
        this._typeDialog = input.typeDialog
        this.creatDialogService(input.inputModal)


        // Chờ kết quả từ callback
        this.showModalAndWait();
        // this._dialog?.showModal(true)
    }


    // Hiển thị modal và chờ xác nhận
    async showModalAndWait(): Promise<void> {
        this._dialog?.showModal(true);
        await this.waitForUserAction();
    }

    // Phương thức chờ người dùng nhấn nút OK hoặc Cancel
    private waitForUserAction(): Promise<{ status: boolean; action: string }> {
        return new Promise((resolve) => {
            this.promiseResolve = resolve; // Gán resolve để sau này gọi khi bấm nút

            const btnOk = document.getElementById(`btn-ok-${this._IdGeneral}`);
            btnOk?.addEventListener("click", () => {
                this._action = "Ok"; // Gán action là "Ok"
                this.notifyCallBack(false); // Đóng modal và gọi callback
                this.promiseResolve({ status: true, action: "Ok" }); // Giải phóng Promise khi bấm OK
            });


        });
    }



    // Thông báo trạng thái và đóng modal
    private notifyCallBack(status: boolean): void {
        if (this._dialog) {
            this._dialog.showModal(false); // Đóng modal
            this._dialog.destroyDialog();  // Hủy modal sau khi đóng
        }
    }

    private handleCloseModal = (status: boolean) => {
        this._action = "closed"
        if (!status) {
            this.notifyCallBack(status)

        }
    }

    // // Gọi callback để thông báo thay đổi trạng thái
    // notifyCallBack(status: boolean): void {
    //     if (this.onClosedCallback) {
    //         this.onClosedCallback(status, this._action); // Thông báo cho lớp cha
    //         if (!status) {

    //             this._dialog?.showModal(false)
    //             this._dialog?.destroyDialog()

    //         }
    //     } else {
    //         console.error("State change callback is not set.");
    //     }
    // }

    creatDialogService = (input: IIunputModalService) => {
        this._dialog = new DialogGeneral(
            this._containerId,
            this.handleCloseModal
        );
        this._dialog.zIndex = 1000
        this._dialog.innerHeader = this._renderHeader()
        this._dialog.topModal = "50%"
        this._dialog.leftModal = "50%"
        this._dialog.firstLoad = false
        this._dialog.minHeightModal = 140
        this._dialog.minWidthModal = 250
        // this._dialog.widthModal = "400px"
        // this._dialog.heightModal = "400px"
        this._dialog.isModal = true
        this._dialog.enableResize = false
        this._dialog.innerBody = this.renderBodyDialog(input);
        this._dialog.createDialog();

        // const btn = document.getElementById(`btn-ok-${this._IdGeneral}`)
        // btn?.addEventListener("click", () => {
        //     this._action = "Ok"
        //     this.notifyCallBack(false)
        // })

    }

    //#region renderBodyDialog
    private _containerDiv: HTMLDivElement | undefined

    renderBodyDialog = (inputModal: IIunputModalService) => {
        if (this._containerDiv) {
            this.clearContainer()
        } else {
            this._containerDiv = document.createElement('div')
            this._containerDiv.className = 'service-dialog-body-dialog';
        }
        this._containerDiv.innerHTML =
            `
            <div style="display:grid;grid-template-columns: 50px 1fr;;width:100%;height: calc(100% - 25px)">
            <div class="container-icon-type-dialog">
                <div class="icon">
                    ${this._renderTypeDialog()}
                </div>
            </div>

            <div class="container-content-type-dialog">
                <div class="content-header">${inputModal.contentHeader}</div>
                <div class="content-body">${inputModal.contentBody}</div>
            </div>
            </div>
            <div style="width:100%;display:flex;justify-content: end;margin-top:10px">
                <button id="btn-ok-${this._IdGeneral}" class="btn-ok-modal" style="width:50px">
                    OK
                </button>
            </div>
            </div>
        `
        // this._containerDiv.appendChild(this._optionExtension.htmlElement!)

        return this._containerDiv
    }

    private _renderTypeDialog = () => {
        switch (this._typeDialog) {
            case ETypeDialogService.Warning:
                return IconDialogWarning()
            case ETypeDialogService.Error:
                return IconDialogErrorRed()

            case ETypeDialogService.Info:
                return IconDialogInfo()
            case ETypeDialogService.Success:
                return IconDialogSuccess()


            default:
                break;
        }

    }

    private _renderHeader = () => {
        switch (this._typeDialog) {
            case ETypeDialogService.Warning:
                return getMessage("dialog-service-warning")
            case ETypeDialogService.Error:
                return getMessage("dialog-service-error")

            case ETypeDialogService.Info:
                return getMessage("dialog-service-info")

            case ETypeDialogService.Success:
                return getMessage("dialog-service-success")


            default:
                break;
        }
    }


    private clearContainer = () => {
        if (this._containerDiv) {
            while (this._containerDiv.firstChild) {
                this._containerDiv.removeChild(this._containerDiv.firstChild);
            }
        }
    }
}